module.exports = __webpack_public_path__ + "img/W-S10.8f847d3f.jpg";